import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("root")!;

createRoot(container).render(<App />);

/**
 * Drop the static boot shell once React has committed its first tree.
 *
 * The shell is the plain-HTML loading screen in client/index.html that gives the
 * browser something to paint before the bundle parses (without it, #root is
 * empty and first contentful paint waits on React — ~4s on the mobile profile).
 * It is not React's, so something has to take it away, and the timing matters:
 *
 *  - MutationObserver callbacks run after the DOM change but *before* the
 *    browser paints that frame, so the shell disappears in the same frame
 *    React's own <Preloader> appears. Handing over any later would flash the
 *    page; handing over any earlier would show a blank frame.
 *  - Waiting for `childElementCount > 0` rather than for a timer means the
 *    shell goes exactly when there is something to replace it with, on any
 *    connection speed.
 *
 * If React never mounts, the shell stays — which is the better failure mode: a
 * visitor sees the loading screen rather than an empty dark page.
 */
const bootShell = document.getElementById("boot-shell");
if (bootShell) {
  const observer = new MutationObserver(() => {
    if (container.childElementCount > 0) {
      observer.disconnect();
      bootShell.remove();
    }
  });
  observer.observe(container, { childList: true });
}
